import styled from 'styles/styled';

/**
 * Modal-specific scaffolding for OverpaymentModal. The body content
 * (success badge, divider, compare rows, delta block, hint, continue
 * CTA) is now imported from screens/Authenticated/PaymentQR/styled —
 * the modal is a thin wrapper that reuses the DS-4 detected/overpaid
 * styled components instead of duplicating their token values here.
 */

export const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const Card = styled.div`
  background-color: #15191e;
  padding: 32px 24px 24px;
  position: relative;
  border-radius: 24px;
  min-width: 390px;
  max-width: 460px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (max-width: 720px) {
    min-width: initial;
    width: 380px;
    max-width: calc(100% - 40px);
    padding: 24px 16px 20px;
    border-radius: 16px;
  }
`;

/**
 * Close button — DS-4 surface-2 token instead of the previous
 * #454545 ad-hoc grey. SVG glyph replaces the unicode "✕" so the
 * stroke weight stays consistent with other close affordances.
 */
export const CloseButton = styled.button`
  position: absolute;
  right: 12px;
  top: 12px;
  width: 32px;
  height: 32px;
  background: #292B2E;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #A7A8B2;
  transition: background 200ms ease-in, color 200ms ease-in, border-color 200ms ease-in;

  &:hover {
    background: #1B1F25;
    color: #EFEFEF;
    border-color: rgba(255, 255, 255, 0.12);
  }

  &:focus-visible {
    outline: 2px solid #52D381;
    outline-offset: 2px;
  }
`;

/**
 * Title — DS-4 detected-title spec (26/700/-0.005em / text-wrap balance).
 * The "joined" word inherits the bull-green emphasis via the inline span.
 */
export const Title = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 26px;
  font-weight: 700;
  color: #EFEFEF;
  line-height: 32px;
  letter-spacing: -0.005em;
  text-wrap: balance;
  margin: 12px 0 10px;

  span {
    color: #52D381;
  }

  @media (max-width: 720px) {
    font-size: 22px;
    line-height: 28px;
  }
`;

/**
 * Subtitle — DS-4 detected-sub spec (13/300/fg-2 / max-width 480 / lh 1.5).
 */
export const Subtitle = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 300;
  color: #A7A8B2;
  line-height: 1.5;
  text-align: center;
  max-width: 480px;
  margin: 0 auto 24px;
`;
